
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30.5 23C31.0523 23 31.5 22.5523 31.5 22C31.5 21.4477 31.0523 21 30.5 21L30.5 23ZM12.7929 21.2929C12.4024 21.6834 12.4024 22.3166 12.7929 22.7071L19.1569 29.0711C19.5474 29.4616 20.1805 29.4616 20.5711 29.0711C20.9616 28.6805 20.9616 28.0474 20.5711 27.6569L14.9142 22L20.5711 16.3431C20.9616 15.9526 20.9616 15.3195 20.5711 14.9289C20.1805 14.5384 19.5474 14.5384 19.1569 14.9289L12.7929 21.2929ZM30.5 21L13.5 21L13.5 23L30.5 23L30.5 21Z","fill":"#212A4B","fill-opacity":"0.46"}})])
          )
        }
      }
    